import { useViewportStore } from '../../stores/viewportStore';

interface SmartGuidesProps {
  containerWidth: number;
  containerHeight: number;
}

export default function SmartGuides({ containerWidth, containerHeight }: SmartGuidesProps) {
  const { activeGuides, zoom, panX, panY } = useViewportStore();

  if (activeGuides.length === 0) return null;

  return (
    <div
      className="absolute inset-0 pointer-events-none z-[5]"
      style={{ width: containerWidth, height: containerHeight }}
    >
      {activeGuides.map((guide, i) => {
        const isArtboardCenter = guide.type === 'center' && guide.source === 'artboard';
        const isElementCenter = guide.type === 'center' && guide.source !== 'artboard';
        const color = isArtboardCenter
          ? 'rgba(236, 72, 153, 0.9)'
          : isElementCenter
            ? 'rgba(251, 146, 60, 0.85)'
            : guide.type === 'grid'
              ? 'rgba(34, 211, 238, 0.3)'
              : 'rgba(6, 182, 212, 0.8)';

        if (guide.orientation === 'vertical') {
          const screenX = guide.position * zoom + panX;
          return (
            <div
              key={`guide-${i}`}
              className="absolute top-0 bottom-0"
              style={{ left: screenX, width: 1, backgroundColor: color }}
            />
          );
        }

        const screenY = guide.position * zoom + panY;
        return (
          <div
            key={`guide-${i}`}
            className="absolute left-0 right-0"
            style={{ top: screenY, height: 1, backgroundColor: color }}
          />
        );
      })}
    </div>
  );
}
